
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/new-grad-scout",
      function () {
        return require("private-next-pages/next/new-grad-scout/index.tsx");
      }
    ]);
  